export default __webpack_public_path__ + "static/background-2-e20eb33ae16dec7805567d8cfb44b7f8.png";